import { FilterDropdownConfig } from 'components/CruiseSearchWidget/types';
import { getTotalSelectionForFilter } from 'components/CruiseSearchWidget/utils/reducers';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { CaretIcon } from 'components/Icon';
import { PillButton } from 'components/buttons/PillButton/PillButton';
import { useAppContext } from 'contexts/appContext';
import { useCallback } from 'react';
import styles from './AllFiltersList.css';

interface AllFilterListProps {
	testId: string;
}

export function AllFiltersList({ testId }: Readonly<AllFilterListProps>) {
	const { enabledFilters, setActiveFilter, historicalSelection, removeHistoricalSelectionPill, filterKeyToCustomFilterConfig, enableUniqueFilters } =
		useFiltersContext();
	const { dictionary } = useAppContext();

	const renderSelectedOptions = useCallback(
		(filter: FilterDropdownConfig) => {
			const selectedOptions = getTotalSelectionForFilter(historicalSelection, filter, filterKeyToCustomFilterConfig, enableUniqueFilters);

			if (selectedOptions.length === 0) {
				return <></>;
			}

			return (
				<div className={styles.options}>
					{selectedOptions.map((pillValue) => (
						<PillButton
							key={pillValue.option.code}
							testId={`option-${pillValue.option.label}-pill-button`}
							label={pillValue.option.formattedLabel ?? pillValue.option.label}
							showCross={true}
							onCrossClick={() => removeHistoricalSelectionPill(pillValue)}
						/>
					))}
				</div>
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[removeHistoricalSelectionPill, historicalSelection],
	);

	return (
		<div className={styles.root}>
			<menu>
				{enabledFilters.map((filter) => (
					<li
						className={styles.filter}
						key={`${testId}_${filter.label}`}
						data-testid={filter.mobileTestId}
						onClick={() => setActiveFilter(filter)}
						onKeyDown={() => setActiveFilter(filter)}
					>
						<div className={styles.label}>
							<span>{dictionary[filter.dictionaryLabel]}</span>
							<CaretIcon className={styles.icon} />
						</div>
						{renderSelectedOptions(filter)}
					</li>
				))}
			</menu>
		</div>
	);
}
